import {
  Alert,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import TagDrawer from "../Tags/TagDrawer";
import TagSelect from "../Tags/TagSelect";
import useTagSelect from "../Tags/useTagSelect";

export default function EditWidget({
  isOpen,
  onClose,
  selectedWidget,
  refreshTable,
}) {
  const baseUrl = getHostDomain();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
      widget_type: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
      };
      const response = await fetchController(
        `${baseUrl}/api/v1/widget/${selectedWidget.id}`,
        "PUT",
        payload
      );

      toast.success(response?.message || "Widget updated successfully");
      refreshTable();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Something went wrong");
    }
  };
  useEffect(() => {
    if (selectedWidget) {
      setValue("name", selectedWidget.widget_name || selectedWidget.name);
      setValue("description", selectedWidget.description);
      setValue("widget_type", selectedWidget.widget_type);
    }
  }, [selectedWidget]);

  const tagSelectHook = useTagSelect({
    entity_id: selectedWidget?.id,
    entity_type: "widget",
  });

  const handleCloseWidget = () => {
    onClose();
    refreshTable();
  };
  return (
    <Modal isOpen={isOpen} onClose={handleCloseWidget}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Widget</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(); }}>
          <ModalBody pb={6} display={"flex"} flexDirection={"column"} gap={4}>
            <FormControl isInvalid={errors.name}>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Enter name"
                {...register("name", { required: "Name is required" })}
              />
              <FormErrorMessage>
                {errors.name && errors.name.message}
              </FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={errors.description}>
              <FormLabel>{"Description"}</FormLabel>
              <Textarea
                placeholder="Enter description"
                {...register("description", {
                  required: "Description is required",
                })}
                resize="vertical"
                minHeight="80px"
              />
              <FormErrorMessage>
                {errors.description && errors.description.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="4">
              <FormLabel
                htmlFor="tagSelect"
                display={"flex"}
                alignContent="center"
              >
                <Text alignSelf="center">Select tags</Text>
              </FormLabel>
              <TagSelect tagSelectHook={tagSelectHook} />
            </FormControl>
            <Alert status="info">
              {"Create a new Widget for configuration changes."}
            </Alert>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              type="button"
              mr={3}
              isLoading={isSubmitting}
              onClick={() => handleSubmit(onSubmit)()}
            >
              Update
            </Button>
            <Button onClick={handleCloseWidget}>Cancel</Button>
          </ModalFooter>
        </form>
      </ModalContent>
      {isOpen && (
        <TagDrawer
          isOpen={tagSelectHook.tagDrawerDisclosure.isOpen}
          onClose={tagSelectHook.tagDrawerDisclosure.onClose}
          tagToEdit={tagSelectHook.tagToEdit}
          setTagToEdit={tagSelectHook.setTagToEdit}
          cb={tagSelectHook.onCreateTag}
        />
      )}
    </Modal>
  );
}
